// Tax rate as a percent label, keeping fractional rates exact (0.09975 -> "9.975%")
// while trimming trailing zeros (0.05 -> "5%"). Rounding would misstate a legal VAT rate.
export const formatPercent = rate => `${parseFloat((Number(rate) * 100).toFixed(3))}%`;

export const formatRates = rates => rates.map(formatPercent).join(' + ');

export const parseAmount = raw => {
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
};

// Validates a non-negative decimal amount input: trims whitespace, drops scientific-notation
// chars, collapses leading zeros, and caps the decimal places for the currency. Returns '' for
// an empty field and null when the result isn't a non-negative number or exceeds `max`, so the
// caller can ignore the keystroke and keep the previous value (rather than coercing garbage
// into a number).
export const getValidAmountInput = (raw, decimals = 2, max) => {
  let input = String(raw == null ? '' : raw).replace(/\s+/g, '');
  if (input === '') return '';
  input = input.replace(/[eE]/g, '');
  if (input === '') return null;
  input = input.replace(/^0+(?=\d)/, '');
  input = decimals
    ? input.replace(new RegExp(`^(\\d+\\.\\d{${decimals}})\\d+`), '$1')
    : input.replace(/^(\d+)\..*/, '$1');
  if (!(Number(input) >= 0)) return null;
  if (typeof max === 'number' && Number(input) > max) return null;
  return input;
};
